import React from "react";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../../constants/constants";
import TotalAmountField from "./totalAmountField";
import { useIntl } from "react-intl";

const Summary = props => {
  const { selectedRows, mergeType } = props;

  const residualText = useIntl().formatMessage({ id: "deadlines.merge.residual" });
  const deadlineTotalAmountText = useIntl().formatMessage({
    id: "deadlines.merge.deadlineTotalAmount"
  });
  const description1Text = useIntl().formatMessage({ id: "deadlines.merge.description1" });
  const genericDescription = useIntl().formatMessage({ id: "generic.description" });
  const amountText = useIntl().formatMessage({ id: "deadlines.amount" });
  const deadlineDateNew = useIntl().formatMessage({ id: "deadlines.deadlineDateNew" });

  let rows = [];
  let finalAmount = 0;
  selectedRows.map(element => {
    if (element) {
      finalAmount += element.amount;
      rows.push(<div className={"deadlinesDialogMerge-table1-row"}>
        <div className={"deadlinesDialogMerge-table1-col col1"}>
          {element.description} 
        </div>
        <div
          className={"deadlinesDialogMerge-table1-col col2"}
          style={{ textAlign: "right" }}
        >
          {<TotalAmountField totalAmount={element.amount} />}
        </div>
        <div className={"deadlinesDialogMerge-table1-col col3"}>
          {moment(element.date).format(DATE_FORMAT_FOR_DISPLAY)}
        </div>
      </div>);
    }
    return rows;
  });
  rows.push(<div className={"deadlinesDialogMerge-table1-row finalAmount"}>
    <div className={"deadlinesDialogMerge-table1-col col1"}>
      {mergeType === "compensation"
        ? residualText
        : deadlineTotalAmountText}
    </div>
    <div
      className={"deadlinesDialogMerge-table1-col col2"}
      style={{ textAlign: "right" }}
    >
      {<TotalAmountField totalAmount={finalAmount} />}
    </div>
    <div className={"deadlinesDialogMerge-table1-col col3"}></div>
  </div>);
  return (
    <div>
      <div className={"deadlinesDialogMerge-description1"}>
        {description1Text}
      </div>
      <section className={"deadlinesDialogMerge-table1"}>
        <header className={"deadlinesDialogMerge-table1-header"}>
          <div className={"deadlinesDialogMerge-table1-col col1"}>
            {genericDescription}
          </div>
          <div
            className={"deadlinesDialogMerge-table1-col  col2"}
            style={{ textAlign: "right" }}
          >
            {amountText}
          </div>
          <div className={"deadlinesDialogMerge-table1-col col3"}>
            {deadlineDateNew}
          </div>
        </header>
        {rows}
      </section>
    </div>
  );
};

export default Summary;
